export class ContextContainer {
    constructor(context) {
        this.context = context;
    }
}
